import React, { useState, useEffect, useContext } from 'react';
import './Journey.scss';

import { motion, AnimatePresence } from 'framer-motion';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
} from '../../animations';
import { useInView, InView } from 'react-intersection-observer';
import { useHistory } from 'react-router-dom';

//import { journeyList } from './JourneyList';
import ParticularJourney from './ParticularJourney';
import { DataContext } from '../../Contexts/DataContext';

const Journey = (props) => {
  const { journey } = useContext(DataContext);

  const [top, setTop] = useState(0);
  const handleScroll = (e) => {
    setTop(e.target.scrollTop);
  };
  useEffect(() => {
    if (top > 170) props.setDarkenNavbar(true);
    else props.setDarkenNavbar(false);
  }, [top]);

  return (
    <motion.div
      className="Journey_Page"
      variants={pageTransitions}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div
        className="Journey_Page__page-content Scrollable"
        onScroll={handleScroll}
      >
        <motion.div
          className="Projects_Page__page-content__Title"
          variants={fadeinslow}
          initial="hidden"
          animate="visible"
        >
          <div className="Journey_Page__page-content__Title-heading">
            JOURNEY
          </div>

          <div className="Journey_Page__page-content__Title-details">
            Web Developer | Student | Competitive Programmer
          </div>
        </motion.div>

        <motion.div className="Journey_Page__page-content__Info margin-bottom-big">
          <div class="timeline">
            {journey &&
              journey.map((data, index) => {
                return <ParticularJourney data={data} index={index} />;
              })}
            {/* <div class="container left">
              <div class="content">
                <h2>2017</h2>
                <p>Lorem ipsum..</p>
              </div>
            </div>
            <div class="container right">
              <div class="content">
                <h2>2016</h2>
                <p>Lorem ipsum..</p>
              </div>
            </div>
            <div class="container left">
              <div class="content">
                <h2>2016</h2>
                <p>Lorem ipsum..</p>
              </div>
            </div>
            <div class="container right">
              <div class="content">
                <h2>2016</h2>
                <p>Lorem ipsum..</p>
              </div>
            </div> */}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};
export default Journey;
